<template>
  <div class="additional-tags" v-if="!inline">
    <transition-group tag="div" name="list" class="additional-tags__list">
      <div class="additional-tags__item"
           v-for="item in ingredients"
           :key="item.ingredient.id"
      >
        <span>{{ item.ingredient.name }}</span>
        <span class="additional-tags__item-price" v-if="!isMain">,&nbsp;{{ item.ingredient.price }} {{ $t('грн') }}&nbsp;</span>
        <span class="additional-tags__item-count">&nbsp;(х {{ item.quantity }})</span>
        <button type="button"
                class="additional-tags__item-delete"
                @click="onDelete(item)">
          <i class="fa fa-close"></i>
        </button>
      </div>
    </transition-group>
  </div>
  <div v-else class="additional-tags _inline">
    <span v-for="item in ingredients"
          :key="item.ingredient.id">{{ item.ingredient.name }} (х{{ item.quantity }})</span>
  </div>
</template>

<script>
  export default {
    name: 'AdditionalTags',
    props: {
      ingredients: null,
      inline: {
        type: Boolean,
        default: false
      },
      isMain: Boolean
    },
    methods: {
      onDelete(ingredient) {
        this.$emit('delete', ingredient)
      }
    }
  }
</script>

<style>

</style>
